import { GA } from 'types';

export interface CTAClickData {
  type: GA.EventType.CTA_CLICK;
  itemType: GA.ItemType.BUTTON | GA.ItemType.LINK | GA.ItemType.IMAGE;
  itemText: string;
  url?: string;
}

export interface CTAClickEvent {
  event: CTAClickData['type'];
  event_data: {
    action: GA.Action.CLICK;
    component_type: GA.ComponentType.CTA;
    item_type: CTAClickData['itemType'];
    item_text: CTAClickData['itemText'];
    url?: CTAClickData['url'];
  };
}

const getCTAClickEvent = (data: CTAClickData): CTAClickEvent => {
  const { type, itemType, itemText, url } = data;

  return {
    event: type,
    event_data: {
      action: GA.Action.CLICK,
      component_type: GA.ComponentType.CTA,
      item_type: itemType,
      item_text: itemText,
      ...(url && { url }),
    },
  };
};

export default getCTAClickEvent;
